import { render, staticRenderFns } from "./PublicPlaceComplementModal.vue?vue&type=template&id=dd0d0f0c&"
import script from "./PublicPlaceComplementModal.vue?vue&type=script&lang=js&"
export * from "./PublicPlaceComplementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports